// @flow

export const RECEIVED_FOOTER_SETTINGS: 'listo/footerSettings/RECEIVED_FOOTER_SETTINGS' = 'listo/footerSettings/RECEIVED_FOOTER_SETTINGS';

export default null;
